import { useQuery } from "@tanstack/react-query";
import { http } from "../../utils";
import { dataTableParamsBuilder } from "../../utils/data-table-params-builder";
import { usePaginationQuery } from "../../utils/hooks";

export async function fetchProductById(id) {
  const { data } = await http(`/admin/products/${id}`);

  return data;
}

export function useProductById(id) {
  const { data, ...raResult } = useQuery(["products", id], () =>
    fetchProductById(id)
  );

  return {
    ...raResult,
    data: data ?? {},
  };
}

function fetchInventoryStockHistory(params, id) {
  const baseUrl = window.location.origin;
  const endpointUrl = new URL(
    `/admin/product-stock-histories?productId=${id}`,
    baseUrl
  );

  if (params.categoryId) {
    endpointUrl.searchParams.append("categoryId", params.categoryId);
  }
  
  if (params.type) {
    endpointUrl.searchParams.append("type", params.type);
  }

  if (params.productGroupName) {
    endpointUrl.searchParams.append(
      "productGroupName",
      params.productGroupName
    );
  }

  if (params.from) {
    endpointUrl.searchParams.append("from", params.from);
  }
  if (params.to) {
    endpointUrl.searchParams.append("to", params.to);
  }

  if (params.saleStatus) {
    endpointUrl.searchParams.append("saleStatus", params.saleStatus);
  }

  dataTableParamsBuilder({
    searchParams: endpointUrl.searchParams,
    filterValues: [params.order],
    ...params,
  });

  return http(endpointUrl.toString().replace(baseUrl, ""));
}

export function useInventoryStockHistory(params = {}, id) {
  return usePaginationQuery(
    [
      "product-stock-histories",
      params.keyword,
      params.categoryId,
      params.productGroupName,
      params.type,
      params.from,
      params.to,
      params.saleStatus,
    ],
    (paginationState) =>
      fetchInventoryStockHistory({ ...params, ...paginationState }, id)
  );
}

export async function fetchStockSummary(id) {
  const { data } = await http(
    `/admin/product-stock-histories-summary?productId=${id}`
  );

  return data;
}

export function useStockSummary(id) {
  const { data, ...raResult } = useQuery(
    ["product-stock-histories-summary"],
    () => fetchStockSummary(id)
  );

  return {
    ...raResult,
    data: data ?? {},
  };
}



export async function fetchStockHistoryDownload() {
  const { data } = await http(`/admin/product-stock-histories-download`, {
    responseType: "blob",
  });

  return data;
}